








































































import Vue from 'vue'
import { BubbleBarElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BubbleBarEl',
  props: {
    templateItemData: {
      type: Object as () => BubbleBarElInterface,
      required: true
    }
  },
  computed: {
    leftBubbleStyle (): string {
      return 'background: ' + this.templateItemData.leftBubble.backgroundColor + '; color: ' +
        this.templateItemData.leftBubble.color + ';'
    },
    rightBubbleStyle (): string {
      return 'background: ' + this.templateItemData.rightBubble.backgroundColor + '; color: ' +
        this.templateItemData.rightBubble.color + ';'
    },
    leftTimelineStyle (): string {
      return 'border-top: 5px solid ' + this.templateItemData.leftBubble.backgroundColor + ';' +
        'border-left: 1px solid ' + this.templateItemData.leftBubble.backgroundColor + ';' +
        'border-right: 1px solid ' + this.templateItemData.leftBubble.backgroundColor + ';'
    },
    rightTimelineStyle (): string {
      return 'border-top: 5px solid ' + this.templateItemData.rightBubble.backgroundColor + ';' +
        'border-right: 1px solid ' + this.templateItemData.leftBubble.backgroundColor + ';'
    },
    dynamicStyles (): string {
      const maxTimelineWidth = 90
      const leftTimelineWidth = (maxTimelineWidth * this.templateItemData.val) / this.templateItemData.maxVal

      return '--left-background-color: ' + this.templateItemData.leftBubble.backgroundColor + ';' +
        '--right-background-color: ' + this.templateItemData.rightBubble.backgroundColor + ';' +
        '--left-timeline-width: ' + leftTimelineWidth + '%;' +
        '--right-timeline-width: ' + (maxTimelineWidth - leftTimelineWidth) + '%;'
    }
  }
})
